<template>
  <div class="appointment-list">
    <el-table class="table" :data="list" stripe :header-row-style="{color:'#333333'}">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table class="table" :data="scope.row.sessions">
            <el-table-column label="日期" width="150" prop="day">
            </el-table-column>
            <el-table-column label="时间" width="150" prop="created_at">
              <template slot-scope="session">
                <p>{{timeFormat(session.row.start_time)}}&nbsp;-&nbsp;{{timeFormat(session.row.end_time)}}</p>
              </template>
            </el-table-column>
            <el-table-column label="预约截止" width="150">
              <template slot-scope="session">
                <p>{{session.row.bookable_before_at && getDay(session.row.bookable_before_at)}}</p>
              </template>
            </el-table-column>
            <el-table-column label="预约人数" prop="sales" width="120">
            </el-table-column>
            <el-table-column label="库存" prop="stock" width="120">
            </el-table-column>
            <el-table-column label="价格" width="120">
              <template slot-scope="session">
                <p>{{session.row.price/100}}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="session">
                <el-button type="text" size="small" @click="sessionPeople(session.row)">查看</el-button>
                <el-button type="text" size="small" @click="editSession(scope.row,session.row)">编辑</el-button>
                <el-button type="text" size="small" @click="deleteSession(session.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="标题" prop="title" width="250">
      </el-table-column>
      <el-table-column label="场次" width="120">
        <template slot-scope="scope">
          <span>{{scope.row.sessions.length}}</span>
        </template>
      </el-table-column>
      <el-table-column label="预约人数" width="120">
        <template slot-scope="scope">
          <span>{{sessionPeopleCount(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="总库存" width="120">
        <template slot-scope="scope">
          <span>{{totalStock(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="显示/隐藏" width="180">
        <template slot-scope="scope">
          <el-switch :active-value="0" :inactive-value="1" v-model="scope.row.is_hidden" @change="change($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
        <template slot-scope="scope">
          <span class="small gray">{{getDay(scope.row.created_at)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
          <el-button type="text" size="small" @click="showRoutes(scope.row)">路径</el-button>
          <el-button type="text" size="small" @click="preview(scope.row)">预览</el-button>
          <el-button type="text" size="small" @click="addSession(scope.row)">添加场次</el-button>
          <el-button type="text" size="small" @click="downloadFile(scope.row.uuid)">导出</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :page-sizes="[5, 10, 15, 20]" :current-page="page" :page-size="per_page" layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <el-dialog title="编辑" :visible.sync="dialogVisible" width="1130px" append-to-body>
      <editBooking :uuid="current.uuid" @update-success="updateSuccess"></editBooking>
    </el-dialog>
    <el-dialog :visible.sync="isShowRoutes" title="路径" center width="800px">
      <el-form label-width="80px">
        <el-form-item label="小程序">
          <el-input :value="'/pages/presell/index?uuid=' + current.uuid">
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="isEdit?'编辑场次':'添加场次'" :visible.sync="editSessiondialogVisible" width="900px">
      <el-form label-width="100px" class="form2">
        <!-- <el-form-item label="名称">
          <el-input v-model="session.name" style="width:400px"></el-input>
        </el-form-item> -->
        <el-form-item label="日期">
          <el-date-picker v-model="session.day" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-input v-model="session.start_time" style="width:400px" placeholder="格式：10:30"></el-input>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-input v-model="session.end_time" style="width:400px" placeholder="格式：10:30"></el-input>
        </el-form-item>
        <el-form-item label="最小人数">
          <el-input-number v-model="session.min_people" :min="1" label="最小人数"></el-input-number>
        </el-form-item>
        <el-form-item label="最大人数">
          <el-input-number v-model="session.max_people" :min="1" label="最大人数"></el-input-number>
        </el-form-item>
        <el-form-item label="库存">
          <el-input v-model.number="session.stock" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="价格" v-if="current.is_need_pay">
          <el-input v-model.number="session.price" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="截止预约时间">
          <el-date-picker v-model="session.bookable_before_at" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editSessiondialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSession">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="sessionPeopleDialogVisible" title="已预约用户" width="1000px">
      <el-row style="padding-left:3px;">
        <el-table class="table" :data="people">
          <el-table-column label="姓名" width="250">
            <template slot-scope="scope">
              <span>{{scope.row.first_name}}&nbsp;{{scope.row.last_name}}</span>
              <el-tag size="mini">{{scope.row.gender===0?"男":"女"}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="手机">
            <template slot-scope="scope">
              <p>{{scope.row.phone}}</p>
            </template>
          </el-table-column>
		  <el-table-column label="推荐人">
		    <template slot-scope="scope">
		      <p>{{scope.row.inviter}}</p>
		    </template>
		  </el-table-column>
          <el-table-column label="人数" prop="people_total">
          </el-table-column>
          <el-table-column label="状态" prop="union_status_text">
          </el-table-column>
        </el-table>
      </el-row>
      <span slot="footer">
        <el-pagination layout="sizes, prev, pager, next" :current-page="p_page" :page-size="p_per_page" :total="p_total"
          @size-change="handleSizeChange2" @current-change="handleCurrentChange2">
        </el-pagination>
      </span>
    </el-dialog>
    <el-dialog title="扫码预览" center :visible.sync="previewDialogVisible" width="400px">
      <img class="qrcode-img" :src="`data:image/jpeg;base64,${qrcodeUrl}`">
    </el-dialog>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import editBooking from './index'
  import getDay from '@/utils/getDay'
  export default {
    name: 'appointmentList',
    components: {
      editBooking
    },
    data() {
      return {
        list: [],
        page: 1,
        per_page: 10,
        total: 0,
        dialogVisible: false,
        current: {},
        isShowRoutes: false,
        editSessiondialogVisible: false,
        session: {
          day: '', // 天日期
          start_time: '', // 开始时分
          end_time: '', // 结束时分
          min_people: '', // 最小预约人数
          max_people: '', // 最大预约人数
          stock: '', // 库存
          price: 0, // 100元/人, 单位分
          bookable_before_at: ''
        },
        sessionPeopleDialogVisible: false,
        people: [],
        p_page: 1,
        p_per_page: 10,
        p_total: 0,
        previewDialogVisible: false,
        qrcodeUrl: '',
        isEdit: false
      }
    },
    created() {
      this.getBookings()
    },
    methods: {
      change (e, row) {
        request({
          url: '/bookings/' + row.uuid,
          method: 'patch',
          data: {
            type: e ? 'hide' : 'show'
          }
        }).then(() => {}).catch(() => {
          this.getBookings()
        })
      },
      preview(row) {
        request({
          url: '/ui/miniapp-code',
          method: 'post',
          data: {
            path: '/pages/presell/index?uuid=' + row.uuid
          }
        }).then(res => {
          this.qrcodeUrl = res.data.code
          this.previewDialogVisible = true
        })
      },
      sessionPeopleCount(row) {
        let sessions = row.sessions || []
        let total = 0
        sessions.forEach(item => {
          total += item.sales
        })
        return total
      },
      totalStock(row) {
        let sessions = row.sessions || []
        let total = 0
        sessions.forEach(item => {
          total += item.stock
        })
        return total
      },
      sessionPeople(row) {
        this.sessionPeopleDialogVisible = true
        this.session = row
        this.getSessionPeople()
      },
      getSessionPeople() {
        request({
          url: '/book-infos',
          params: {
            session_id: this.session.id,
            page: this.p_page,
            per_page: this.p_per_page
          }
        }).then(res => {
          this.people = res.data.list
          this.p_total = res.data.item_total
        })
      },
      handleSizeChange2(e) {
        this.p_per_page = e
        this.p_page = 1
        this.getSessionPeople()
      },
      handleCurrentChange2(e) {
        this.p_page = e
        this.getSessionPeople()
      },
      timeFormat(time) {
        let timeArr = time.split(':')
        return timeArr[0] + ':' + timeArr[1]
      },
      deleteSession(row) {
        this.$confirm('是否删除场次', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(_ => {
          request({
            url: '/booking-sessions/' + row.uuid,
            method: 'delete'
          }).then(res => {
            this.$message.success('删除成功')
            this.getBookings()
          })
        }).catch(_ => {})
      },
      editSession(row, session) {
        this.current = row
        this.session = JSON.parse(JSON.stringify(session))
        this.session.price = this.session.price / 100
        this.isEdit = true
        this.editSessiondialogVisible = true
      },
      addSession(row) {
        this.current = row
        this.isEdit = false
        this.editSessiondialogVisible = true
      },
      submitSession() {
        let session = this.session
        if (this.isEdit) {
          request({
            url: '/booking-sessions/' + session.uuid,
            method: 'patch',
            data: {
              type: 'update',
              attributes: {
                name: session.name, // 场次名称
                day: session.day, // 天日期
                start_time: session.start_time, // 开始时分
                end_time: session.end_time, // 结束时分
                min_people: session.min_people, // 最小预约人数
                max_people: session.max_people, // 最大预约人数
                stock: session.stock, // 库存
                price: session.price * 100, // 100元/人, 单位分
                bookable_before_at: session.bookable_before_at
              }
            }
          }).then(res => {
            this.$message.success('保存成功')
            this.getBookings()
            this.editSessiondialogVisible = false
          })
        } else {
          request({
            url: '/bookings/' + this.current.uuid + '/sessions',
            method: 'post',
            data: {
              day: session.day, // 天日期
              start_time: session.start_time, // 开始时分
              end_time: session.end_time, // 结束时分
              min_people: session.min_people, // 最小预约人数
              max_people: session.max_people, // 最大预约人数
              stock: session.stock, // 库存
              price: session.price * 100, // 100元/人, 单位分
              bookable_before_at: session.bookable_before_at
            }
          }).then(res => {
            this.$message.success('添加成功')
            this.getBookings()
            this.editSessiondialogVisible = false
          })
        }
      },
      showRoutes(item) {
        this.isShowRoutes = true
        this.current = item
      },
      getDay(date) {
        return getDay(date)
      },
      getBookings() {
        request({
          url: '/bookings',
          params: {
            page: this.page,
            per_page: this.per_page
          }
        }).then(res => {
          this.list = (res.data && res.data.list) || []
          this.total = (res.data && res.data.item_total) || 0
        })
      },
      handleSizeChange(e) {
        this.per_page = e
        this.page = 1
        this.getBookings()
      },
      handleCurrentChange(e) {
        this.page = e
        this.getBookings()
      },
      editItem(item) {
        this.current = item
        this.dialogVisible = true
      },
      deleteItem(row) {
        this.$confirm('是否删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(_ => {
          request({
            url: '/bookings/' + row.uuid,
            method: 'delete'
          }).then(res => {
            this.$message.success('删除成功')
            this.getBookings()
          })
        }).catch(_ => {})
      },
      updateSuccess() {
        this.dialogVisible = false
        this.getBookings()
      },
      downloadFile(uuid) {
        let url = process.env.BASE_API + '/' + process.env.API_PREFIX + `/export/bookings/${uuid}/book-infos`
        window.open(url)
        // request({
        //   url: url,
        //   header:{ 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        // }).then(res => {
        //   console.log(res)
        //   window.op
        //   // let url = window.URL.createObjectURL(res.data)
        //   // let link = document.createElement('a')
        //   // link.style.display = 'none'
        //   // link.href = url
        //   // link.setAttribute('download', 'excel.xls')
        //   // document.body.appendChild(link)
        //   // link.click()
        // })
      }
    }
  }
</script>
<style lang="less" scoped>
  .appointment-list {
    .table {
      border: 1px solid #EBEEF5;
      border-bottom: none;
    }

    .pager {
      margin: 10px 0;
    }

    .qrcode-img {
      width: 300px;
      height: 300px;
      display: block;
      margin: 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/booking/list.vue